<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M8.13034 11.8697C7.83744 11.5768 7.36257 11.5768 7.06968 11.8697C6.77678 12.1626 6.77678 12.6374 7.06968 12.9303L9.46968 15.3303C9.76257 15.6232 10.2374 15.6232 10.5303 15.3303L12.9303 12.9303C13.2232 12.6374 13.2232 12.1626 12.9303 11.8697C12.6374 11.5768 12.1626 11.5768 11.8697 11.8697L10 13.7393L8.13034 11.8697Z"
            fill="#8E8E93"
        />
    </svg>
</template>
